var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecorderMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#FFF",
    stroke: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#027BFC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.111c2.453-.003 4.442-1.99 4.444-4.444V4.444C12.444 1.99 10.454 0 8 0 5.545 0 3.556 1.99 3.556 4.444v6.223C3.558 13.12 5.546 15.108 8 15.11z",
    transform: "translate(15 11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.111 8.889c-.49 0-.889.398-.889.889v.889c0 3.436-2.786 6.222-6.222 6.222-3.436 0-6.222-2.786-6.222-6.222v-.89c0-.49-.398-.888-.89-.888-.49 0-.888.398-.888.889v.889c.006 4.071 3.065 7.49 7.111 7.947v4.497H3.556c-.491 0-.89.398-.89.889 0 .49.399.889.89.889h8.888c.491 0 .89-.398.89-.889 0-.49-.399-.889-.89-.889H8.89v-4.497c4.046-.457 7.105-3.876 7.111-7.947v-.89c0-.49-.398-.888-.889-.888z",
    transform: "translate(15 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorderMic);
export default __webpack_public_path__ + "static/media/recorder-mic.1c0e42bfb52b94a921b2c18ceb3fe50c.svg";
export { ForwardRef as ReactComponent };